export default "__VITE_ASSET__3b53ba14__"